/**
 * Display-only cm → inches on the product-page description.
 * Does not write to Shopify product data. Scoped to
 * .product-page #product-description > .rte text nodes.
 * Remove this file and its <script> tag in product-template.liquid to revert.
 */
(function () {
  var ROOT_SEL = '.product-page #product-description > .rte';
  var SKIP_AFTER = /^\s*[\/(]\s*\d+(?:\.\d+)?\s*(?:"|in(?:ch(?:es)?)?\b)/i;
  var SKIP_BEFORE = /(?:in(?:ch(?:es)?)?|")\s*\([^)]*$/i;

  function alreadyHasInches(text, start, end) {
    if (SKIP_AFTER.test(text.slice(end))) return true;
    if (SKIP_BEFORE.test(text.slice(0, start))) return true;
    return false;
  }

  function convertText(text) {
    if (!text || !/\d/.test(text) || !/cm/i.test(text)) return text;
    var re = /(\d+(?:\.\d+)?)\s*cm\b/gi;
    return text.replace(re, function (full, num, offset) {
      if (alreadyHasInches(text, offset, offset + full.length)) return full;
      var inches = parseFloat(num, 10) / 2.54;
      return full + ' / ' + (Math.round(inches * 10) / 10).toFixed(1) + ' in';
    });
  }

  function convertRoot(root) {
    if (!root || root.getAttribute('data-cw-cm-inches') === 'done') return;
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode: function (node) {
        if (!node.nodeValue || !/\d/.test(node.nodeValue) || !/cm/i.test(node.nodeValue)) {
          return NodeFilter.FILTER_REJECT;
        }
        var tag = node.parentElement && node.parentElement.tagName;
        if (tag === 'SCRIPT' || tag === 'STYLE' || tag === 'NOSCRIPT' || tag === 'TEXTAREA') {
          return NodeFilter.FILTER_REJECT;
        }
        return NodeFilter.FILTER_ACCEPT;
      }
    });
    var nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);
    for (var i = 0; i < nodes.length; i++) {
      var next = convertText(nodes[i].nodeValue);
      if (next !== nodes[i].nodeValue) nodes[i].nodeValue = next;
    }
    root.setAttribute('data-cw-cm-inches', 'done');
  }

  function apply() {
    var roots = document.querySelectorAll(ROOT_SEL);
    for (var i = 0; i < roots.length; i++) convertRoot(roots[i]);
  }

  window.CW_CM_INCHES = {
    convertText: convertText,
    apply: apply,
    rootSel: ROOT_SEL
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', apply);
  } else {
    apply();
  }
  document.addEventListener('shopify:section:load', apply);
})();
